import React from 'react';
import PropTypes from 'prop-types';

import {Box, Checkbox, Paper, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

const SmsOptInCard = (props) => {
  const {clientPhoneNumber, hasOptedInForSms, setHasOptedInForSms} = props;

  return (
    <Paper
      sx={{
        p: '24px',
        borderRadius: '20px',
        boxShadow: 'none',
        backgroundColor: '#FFFFFF',
      }}
    >
      <Stack sx={{gap: '20px'}}>
        <Typography sx={{fontSize: '24px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
          <Translate expression={'caregivermatchingstep.SmsOptInCard.Title'} />
        </Typography>

        <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925', lineHeight: '150%'}}>
          <Translate
            expression={'caregivermatchingstep.SmsOptInCard.PrimaryDisclosure'}
            substitute={{clientPhoneNumber: clientPhoneNumber ? ` (${clientPhoneNumber})` : ''}}
          />
        </Typography>

        <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925', lineHeight: '150%'}}>
          <Translate expression={'caregivermatchingstep.SmsOptInCard.ReplyActionsBeforePrivacy'}/>
          <Box
            component="a"
            href="https://carequilt.ca/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              'color': '#2D2925',
              'textDecoration': 'underline',
              'textUnderlineOffset': '2px',
              '&:hover': {
                color: '#2D2925',
              },
            }}
          >
            <Translate expression={'caregivermatchingstep.SmsOptInCard.PrivacyLinkLabel'} />
          </Box>
          <Translate expression={'caregivermatchingstep.SmsOptInCard.And'} />
          <Box
            component="a"
            href="https://carequilt.ca/Terms&Conditions"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              'color': '#2D2925',
              'textDecoration': 'underline',
              'textUnderlineOffset': '2px',
              '&:hover': {
                color: '#2D2925',
              },
            }}
          >
            <Translate expression={'caregivermatchingstep.SmsOptInCard.TermsLinkLabel'} />
          </Box>
          <Translate expression={'caregivermatchingstep.SmsOptInCard.ReplyActionsAfterTerms'} />
        </Typography>

        <Checkbox
          checked={hasOptedInForSms}
          onChange={setHasOptedInForSms}
          label={
            <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925', lineHeight: '150%'}}>
              <Translate expression={'caregivermatchingstep.SmsOptInCard.AgreeStatement'} />
            </Typography>
          }
        />
      </Stack>
    </Paper>
  );
};

SmsOptInCard.propTypes = {
  clientPhoneNumber: PropTypes.string,
  hasOptedInForSms: PropTypes.bool.isRequired,
  setHasOptedInForSms: PropTypes.func.isRequired,
};

export default React.memo(SmsOptInCard);
